import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class StripeConnectionModel extends Model {
  @attr('string') name!: string;
  @attr('string') code!: string;
  @attr('string') stripeUserId!: string;
  @attr('string') status!: string;
  @attr('boolean') extendedSecurityDepositHold!: boolean;

  @hasMany('property', { inverse: 'stripeConnection', async: false })
  properties!: ModelRegistry['property'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'stripe-connection': StripeConnectionModel;
  }
}
